import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import ProductKeywordList from "../../components/ProductKeyword";

const ProductKeywordPage = (): ReactElement => {
  return (
    <Layout>
      <ProductKeywordList />
    </Layout>
  );
};

export default ProductKeywordPage;
